import template from './alternate-brands-option.html';
import './alternate-brands-option.global.css';

export const AlternateBrandsOptionComponent = {
  template,
  bindings: {
    link: '@',
    name: '@',
    logoFilename: '@',
  },
};
